module.exports = __webpack_public_path__ + "static/media/background.d1aba33a.jpg";